import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon } from 'lucide-react';
export function FinalCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-bg py-20 md:py-28 border-t border-white/5" data-id="element-109">
      <div className="max-w-xl mx-auto px-6 text-center" data-id="element-110">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} transition={{
        duration: 0.5
      }} className="mb-6" data-id="element-111">
          <span className="inline-block w-8 h-px bg-orange-accent/60 align-middle mr-3" data-id="element-112" />
          <span className="font-inter text-xs font-semibold tracking-[0.25em] text-orange-accent/80 uppercase" data-id="element-113">
            Last Chance
          </span>
          <span className="inline-block w-8 h-px bg-orange-accent/60 align-middle ml-3" data-id="element-114" />
        </motion.div>

        {/* Headline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 16
      }} transition={{
        duration: 0.55,
        delay: 0.08
      }} className="font-bebas text-4xl md:text-5xl text-white tracking-wide leading-none mb-5" data-id="element-115">
          Every day you wait,{' '}
          <span className="text-orange-accent" data-id="element-116">
            your collection stays exposed.
          </span>
        </motion.h2>

        {/* Sub-copy */}
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 12
      }} transition={{
        duration: 0.5,
        delay: 0.16
      }} className="font-inter text-base text-concrete/70 leading-relaxed mb-10 max-w-sm mx-auto" data-id="element-117">
          One weekend. One build. No one knows it's there.
        </motion.p>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 12
      }} transition={{
        duration: 0.5,
        delay: 0.24
      }} className="mb-6" data-id="element-118">
          <motion.button onClick={() => document.getElementById('checkout')?.scrollIntoView({
          behavior: 'smooth'
        })} className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 bg-orange-accent text-white font-inter font-bold text-sm uppercase tracking-[0.12em] rounded-sm transition-all duration-300 hover:bg-orange-accent/90 active:scale-[0.98]" whileHover={{
          boxShadow: '0 0 32px rgba(224, 123, 57, 0.35)'
        }} data-id="element-119">
            GET THE BLUEPRINT — $6.36
            <ArrowRightIcon className="w-4 h-4" data-id="element-120" />
          </motion.button>
        </motion.div>

        {/* Trust line */}
        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.5,
        delay: 0.36
      }} className="flex items-center justify-center gap-2 mb-8" data-id="element-121">
          <ShieldCheckIcon className="w-3.5 h-3.5 text-concrete/40 flex-shrink-0" data-id="element-122" />
          <p className="font-inter text-xs text-concrete/40 tracking-wide" data-id="element-123">
            60-day money-back guarantee · Instant download · No subscription
          </p>
        </motion.div>

        {/* Divider */}
        <motion.div initial={{
        opacity: 0,
        scaleX: 0
      }} animate={isInView ? {
        opacity: 1,
        scaleX: 1
      } : {
        opacity: 0,
        scaleX: 0
      }} transition={{
        duration: 0.6,
        delay: 0.44
      }} className="w-16 h-px bg-white/10 mx-auto mb-8" data-id="element-124" />

        {/* Disclaimer */}
        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} className="font-inter text-xs text-concrete/35 max-w-sm mx-auto leading-relaxed" data-id="element-125">
          Digital product. Instant access upon purchase. All sales backed by our
          60-day money-back guarantee.
        </motion.p>
      </div>
    </section>;
}